import { OrbitApi } from "api"

class UserAPI {
  static getPfpByUserId(userId, header = {}) {
    // if(email === 'demo@circles.asia') --> get from indexedDB
    return OrbitApi.httpGet(`/upload?userId=${userId}`, header)
  }

  static uploadPfp(userId, pic, header = {}) {
    return OrbitApi.httpPost(`/upload?userId=${userId}`, header, pic)
  }

  static getUserById(id) {
    return OrbitApi.httpGet(`/user/id/${id}`)
  }

  static getUserByIdByToken(id, faberToken) {
    return OrbitApi.httpGet(`/user/idByToken/${id}`, {
      Authorization: `Bearer ${faberToken}`
    })
  }

  static updateFirstLogin(user, header = {}) {
    return OrbitApi.httpPut(`/user/update/firstLogin/${user._id}`, header, {
      firstLogin: false
    })
  }

  static createUser(user, faberToken) {
    return OrbitApi.httpPut(
      `/user/createByToken`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      user
    )
  }

  static updateUser(user, header = {}) {
    return OrbitApi.httpPut(`/user/update`, header, user)
  }

  static deleteUser(user) {
    return OrbitApi.httpDelete(`/user/delete/${user}`)
  }

  static getUserByQuery(queries, faberToken) {
    let queryString = `/user/getUsers`

    if (Object.keys(queries).length > 0) {
      queryString += '?'

      for (const [key, value] of Object.entries(queries)) {
        queryString += `${key}=${value}&`
      }
    }

    queryString += 'details=1'

    return OrbitApi.httpGet(
      queryString,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }
}

export default UserAPI
